import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledDateCalendarContainer = styled.div`
    .DateCalendar-input-container .Label {
        padding-bottom: ${spaceMixin('xs')};
    }
`;

export const StyledDateCalendarPicker = styled.div`
    background-color: white;
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
    position: absolute;
    top: 80px;
    z-index: 9999;
`;
